// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.notifications.RentalManagerUserNotificationsV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserNotificationsDeleteV2RequestDto,
  UserNotificationsDeleteV2WebDto,
  UserNotificationsMarkAsReadV2RequestDto,
  UserNotificationsMarkAsReadV2WebDto,
  UserNotificationsTrackingV2RequestDto,
} from '../..';

export const RentalManagerUserNotificationsV2WebApiHandler_delete_Path = '/api/web/v2/users/notifications/delete';

/**
 * Delete a notification
 */
export const RentalManagerUserNotificationsV2WebApiHandler_delete = (
  postData: UserNotificationsDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserNotificationsDeleteV2RequestDto, UserNotificationsDeleteV2WebDto>(
    {
      endpoint: RentalManagerUserNotificationsV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Path =
  '/api/web/v2/users/notifications/markAsRead';

/**
 * Mark a notification as read
 */
export const RentalManagerUserNotificationsV2WebApiHandler_markAsRead = (
  postData: UserNotificationsMarkAsReadV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserNotificationsMarkAsReadV2RequestDto, UserNotificationsMarkAsReadV2WebDto>(
    {
      endpoint: RentalManagerUserNotificationsV2WebApiHandler_markAsRead_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserNotificationsV2WebApiHandler_tracking_Path = '/api/web/v2/users/notifications/tracking';

/**
 * Track push notifications events
 */
export const RentalManagerUserNotificationsV2WebApiHandler_tracking = (
  postData: UserNotificationsTrackingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserNotificationsTrackingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserNotificationsV2WebApiHandler_tracking_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
